import React from 'react';
import { NavLink } from 'react-router-dom';

const ProspectsCrumb = () => <NavLink to="/human-resources/prospects">Prospects</NavLink>;

export default ProspectsCrumb;
